import Footer from '../../components/Layout/Footer'
import Header from '../../components/Layout/Header'
import PolicyViewer from '../../components/Utilities/PolicyViewer'
import { setPageTitle } from '../../utils/utilities'

const TITLE = 'Do Not Sell or Share My Personal Information'
const DoNotSell = () => {
  setPageTitle(TITLE)

  return (
    <main className="flex h-screen max-h-screen flex-col overflow-hidden bg-neutral-100 dark:bg-neutral-900">
      <Header />
      <div className="flex flex-col flex-1 overflow-auto">
        <h1 className="text-center py-3 font-bold">{TITLE}</h1>
        <PolicyViewer fieldKey="doNotSell" />
      </div>
      <Footer />
    </main>
  )
}

export default DoNotSell
